import { formatDate } from 'src/utils/dates';
import { ActionColumnFormat } from './ColumnFormatters/ActionColumnFormat';
import { ActionColumnUpload } from './ColumnFormatters/ActionColumnUpload';
import { ActionColumnDelete } from './ColumnFormatters/ActionColumnDelete';
import { ActionColumnDowload } from './ColumnFormatters/ActionColumnDowload';

export const columnsRecord = (
	onUploadedFile,
	onDownload,
	onEye,
	allFiles,
	uniques,
	setLoader,
	offVersions,
	onDelete
) => {
	return [
		{
			dataField: 'nombreOriginal',
			text: 'Nombre',
			className: 'text-center',
		},
		offVersions === true
			? {}
			: {
					dataField: 'id',
					text: 'Archivo',
					classes: 'text-center',
					formatter: ActionColumnUpload,
					formatExtraData: {
						onUploadedFile,
						allFiles,
						uniques,
						setLoader,
					},
			  },
		{
			dataField: 'ruta',
			text: 'Documento',
			classes: 'text-center',
			formatter: ActionColumnDowload,
			formatExtraData: {
				onDownload,
			},
		},
		{
			dataField: 'nombreUsuario',
			text: 'Usuario',
			classes: 'text-center',
		},
		offVersions === true
			? {}
			: {
					dataField: 'fecha',
					text: 'Fecha',
					classes: 'text-center',
			  },
		offVersions === true
			? {}
			: {
					dataField: 'hora',
					text: 'Hora',
					classes: 'text-center',
			  },
		offVersions === true
			? {}
			: {
					dataField: 'idFile',
					text: 'Eliminar',
					classes: 'text-center',
					formatter: ActionColumnDelete,
					formatExtraData: {
						onDelete,
					},
			  },
		offVersions === true
			? {}
			: {
					dataField: 'row',
					text: 'Acciones',
					classes: 'text-center',
					headerClasses: 'text-center',
					formatter: ActionColumnFormat,
					formatExtraData: {
						onEye,
					},
			  },
	];
};

export const columnsRecord2 = (onDownload) => [
	{
		dataField: 'nombre',
		text: 'Nombre',
		classes: 'text-center',
	},

	{
		dataField: 'ruta',
		text: 'Documento',
		classes: 'text-center',
		formatter: ActionColumnDowload,
		formatExtraData: {
			onDownload,
		},
	},
	{
		dataField: 'nombreUsuario',
		text: 'Usuario',
		classes: 'text-center',
	},
	{
		dataField: 'fecha',
		text: 'Fecha',
		classes: 'text-center',
		formatter: (value) => {
			return formatDate('P', new Date(value));
		},
	},
	{
		dataField: 'fecha',
		text: 'Hora',
		classes: 'text-center',
		formatter: (value) => {
			return formatDate('HH:mm', new Date(value));
		},
	},
];
